<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            Danh sách sản phẩm
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errorMessage !== undefined && errorMessage.length > 0" v-for="(error, key) in errorMessage" :key="error">
                        <span>{{error}}</span>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError(key)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="search-component d-flex flex-wrap">
                        <div class="status-container">
                            <div
                                    v-for="status in statusOrder"
                                    :key="status.key"
                                    class="status-item"
                                    :class="{ active: dataSearch.status.value === status.key }"
                                    @click="filterByStatus(status.key)"
                            >
                                <div class="status-icon">
                                    <i :class="status.icon"></i>
                                </div>
                                <div class="status-label">{{ status.label }}</div>
                            </div>
                        </div>
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                            <div class="col-sm-11 d-flex flex-column">
                                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                                    <div class="col-sm-3">
                                        <SelectNormal
                                                :label="dataSearch.store_id.label"
                                                :id="dataSearch.store_id.id"
                                                :placeholder="dataSearch.store_id.placeholder"
                                                :value-default="dataSearch.store_id.value"
                                                @inputValue="onChange($event, dataSearch.store_id.id)"
                                                :required="dataSearch.store_id.required"
                                                :options="dataSearch.store_id.options"
                                        ></SelectNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.pick_date.label"
                                                :id="dataSearch.pick_date.id"
                                                :placeholder="dataSearch.pick_date.placeholder"
                                                :value-default="dataSearch.pick_date.value"
                                                @inputValue="onChange($event, dataSearch.pick_date.id)"
                                                :required="dataSearch.pick_date.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <SelectNormal
                                                :label="dataSearch.deliver_date.label"
                                                :id="dataSearch.deliver_date.id"
                                                :placeholder="dataSearch.deliver_date.placeholder"
                                                :value-default="dataSearch.deliver_date.value"
                                                @inputValue="onChange($event, dataSearch.deliver_date.id)"
                                                :error-text="dataSearch.deliver_date.error"
                                                :is-error="dataSearch.deliver_date.isError"
                                                :required="dataSearch.deliver_date.required"
                                                :options="dataSearch.deliver_date.options"
                                        ></SelectNormal>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-1 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent :label="labelButtonSearch" @click="searchGHTK"></ButtonSearchComponent>
                            </div>
                        </div>
                    </div>
                    <div class="btn-invite-partner">
                        <ButtonAddComponent :width="'200px'" :label="labelButtonCreate" @click="redirectToCreate" ></ButtonAddComponent>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-between mt-4">
                        <div class="action d-flex align-items-center gap-3">
                            <div class="total">
                                {{ CommonText.TOTAL_RECORD(listGHTK.length, paginate.itemCount) }}
                            </div>
                            <div class="dropdown-action">
                                <SelectCustom
                                        :label="selectAction.label"
                                        :id="selectAction.id"
                                        :placeholder="selectAction.placeholder"
                                        :value-default="selectAction.value"
                                        :required="selectAction.required"
                                        :options="selectAction.options"
                                        @action="actionSelect($event)"
                                ></SelectCustom>
                            </div>
                        </div>
                        <div class="action-left d-flex align-items-center gap-3">
                            <div class="dropdown-action">
                                <SelectCustom
                                        :label="selectLimitPage.label"
                                        :id="selectLimitPage.id"
                                        :placeholder="selectLimitPage.placeholder"
                                        :value-default="selectLimitPage.value"
                                        :required="selectLimitPage.required"
                                        :options="selectLimitPage.options"
                                        @action="actionLimitPage($event)"
                                ></SelectCustom>
                            </div>
                        </div>
                    </div>
                    <div class="list-partners-component">
                        <table class="table">
                            <thead>
                            <tr>
                                <th scope="col" style="width: 2%;"><InputCheckboxOne id="select_all" :value-default="checkAll" @inputValue="onChangeSelectAll($event)" :checked="checkAll"></InputCheckboxOne></th>
                                <th scope="col" v-for="header in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }">{{header.label}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="listOrders.length > 0" v-for="order in listOrders" :key="order.id">
                                <td><InputCheckboxOne :id="order.id" :value-default="checkItems[order.id]" @inputValue="onChangeSelectItem($event, order.id)" :checked="checkItems[order.id]"></InputCheckboxOne></td>
                                <td>{{order.store?.name}}</td>
                                <td>{{order.delivery?.m_company_receiver?.company_name}}</td>
                                <td>{{order.status}}</td>
                                <td>{{order.tracking_id}}</td>
                                <td>{{order.shipping_fee}}</td>
                                <td>{{order.pick_date}}</td>
                                <td>{{order.deliver_date}}</td>
                            </tr>
                            <tr v-else>
                                <td colspan="5" class="text-center">Không có dữ lệu được tìm thấy!</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <PaginateComponent v-if="listGHTK.length > 0 && paginate.pageCount > 1" :paginate="paginate" :urlOrigin="urlOrigin" @page="emitPage($event)"></PaginateComponent>
                </div>
            </div>
        </div>
    </div>
</div>
<ModalCalendarComponent @dateSelected="actionDateSelected($event)"></ModalCalendarComponent>
<LoadingComponent v-if="isLoading"></LoadingComponent>

